import React from 'react';
import Svg from '../Svg';

const IconArrowCircleDownRight = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM8.29309 8.29283C8.68361 7.90231 9.31678 7.90231 9.7073 8.29284L14.0002 12.5858V9.00005C14.0002 8.44777 14.4479 8.00005 15.0002 8.00005C15.5525 8.00005 16.0002 8.44777 16.0002 9.00005V15.0001C16.0002 15.5523 15.5525 16.0001 15.0002 16.0001H9.00019C8.4479 16.0001 8.00019 15.5523 8.00019 15.0001C8.00019 14.4478 8.4479 14.0001 9.00019 14.0001H12.586L8.29307 9.70704C7.90255 9.31651 7.90256 8.68335 8.29309 8.29283Z"
    />
  </Svg>
);

export default IconArrowCircleDownRight;
